import React from 'react';
import PropTypes from 'prop-types';
import './HillshadeToggle.css';

const HillshadeToggle = ({ hillshadeOn, toggleHillshade }) => {
  return (
    <button
      onClick={toggleHillshade}
      className='hillshadeToggle'
    >
      {(hillshadeOn) ? 'Hide hillshade layer' : 'Show hillshade layer'}
    </button>
  );
};

export default HillshadeToggle;

HillshadeToggle.propTypes = {
  hillshadeOn: PropTypes.bool.isRequired,
  toggleHillshade: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/HillshadeToggle.jsx